import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import Modal from '@components/ResponsiveModal';
import SimpleButton from '@components/SimpleButton';
import { MODAL_TYPE, TRACKING_ORIGIN } from '@commons/constants';
import Footer from './components/Footer';
import Container from './components/Container';
import Subtitle from './components/Subtitle';
import Title from './components/Title';
import messages from './messages';

const ContainerButton = styled(SimpleButton)`
  width: 82%;
  height: 28px;
  line-height: 0px;
`;

function ErrorModalPreorderTimeFull({
  open,
  intl,
  businessType,
  navigateToVerticalResults,
  trackModalClosed,
  trackModalOpened,
  title,
  description,
}) {
  const goToVerticalResult = () => {
    navigateToVerticalResults(businessType, null);
    trackModalClosed(
      MODAL_TYPE.UNAVAILABLE_DELIVERY_TIME,
      TRACKING_ORIGIN.CLOSE,
      TRACKING_ORIGIN.TYPE,
    );
  };

  trackModalOpened(MODAL_TYPE.UNAVAILABLE_DELIVERY_TIME);
  const modalClasses = { modal: 'modal' };
  const customStyles = {
    overlay: { zIndex: 1999 },
  };
  return (
    <Modal
      centerd
      classNames={modalClasses}
      styles={customStyles}
      showCloseIcon={false}
      open={open}
      onClose={() => {}}
    >
      <Container>
        <Title>{title || intl.formatMessage(messages.title)}</Title>
        <Subtitle>
          {description || intl.formatMessage(messages.subtitle)}
        </Subtitle>
        <Footer>
          <ContainerButton
            elementId="goToresult__secondOption"
            label={intl.formatMessage(messages.button)}
            color="primary"
            onClick={goToVerticalResult}
          />
        </Footer>
      </Container>
    </Modal>
  );
}

ErrorModalPreorderTimeFull.propTypes = {
  open: PropTypes.bool,
  intl: intlShape,
  businessType: PropTypes.string.isRequired,
  navigateToVerticalResults: PropTypes.func.isRequired,
  trackModalClosed: PropTypes.func.isRequired,
  trackModalOpened: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default injectIntl(ErrorModalPreorderTimeFull);
